import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PageShell } from "../components/Layout";
import api from "../lib/api";
import { toast } from "sonner";

export default function AstrologerLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Backend sets an HttpOnly `astro_token` cookie on success — no need to
      // touch localStorage; subsequent requests carry the cookie automatically
      // because the axios instance is configured with withCredentials.
      await api.post("/astrologer/login", { email, password });
      toast.success("Welcome back");
      navigate("/astrologer/dashboard");
    } catch {
      toast.error("Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <PageShell>
      <div className="max-w-md mx-auto px-6 pt-20 pb-24" data-testid="astrologer-login">
        <p className="label-eyebrow">Astrologer portal</p>
        <h1 className="font-serif-display text-5xl mt-3 font-light">Welcome back</h1>
        <p className="text-muted mt-4 font-light">Sign in to manage your clients and conversations.</p>

        <form onSubmit={submit} className="mt-10 space-y-4">
          <div>
            <label className="label-eyebrow">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-2 px-4 py-3 border border-soft rounded-md focus:border-gold outline-none" data-testid="astro-login-email" />
          </div>
          <div>
            <label className="label-eyebrow">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-2 px-4 py-3 border border-soft rounded-md focus:border-gold outline-none" data-testid="astro-login-password" />
          </div>
          <button type="submit" disabled={loading} className="btn-primary rounded-full w-full py-3.5 font-medium" data-testid="astro-login-submit">
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>

        <div className="text-muted text-sm mt-8 text-center">
          New to AstroKuber? <Link to="/astrologer/register" className="text-gold" data-testid="astro-register-link">Apply to onboard</Link>
        </div>
      </div>
    </PageShell>
  );
}
